import { jsx as n } from "react/jsx-runtime";
import { L as c } from "../../../../../link-CBjEeGbl.js";
const m = ({
  href: o,
  openNewTab: t,
  alternativeAction: r,
  onAlternativeAction: e
}) => o ? /* @__PURE__ */ n(c, { href: o, color: "secondary", ...t && { target: "_blank", rel: "noopener" }, children: r }) : /* @__PURE__ */ n("button", { onClick: () => e?.(), children: r });
export {
  m as AlternativeAction
};
